export const ManhRouter=[
    {
        path: 'ManhRouter',
        component: () => import('@/views/test/ManhTest.vue')
    }
]